module.exports = __webpack_public_path__ + "img/石菖蒲.163ae611.jpg";